<template>
  <div class="popular-badge">
    <div class="popular-badge__text popular-badge__text--small">Most Popular</div>
    <div class="popular-badge__text popular-badge__text--large">
      <div>Most</div>
      <div>Popular</div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "frontend/init/jiffy/settings";
@import "frontend/init/jiffy/mixin";
@import "../ArtworkQualityConfigPanel.scss";

.popular-badge {
  display: flex;
  width: 100%;
  padding: 8px 18px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  width: fit-content;
  border-radius: 8px;
  background: linear-gradient(90deg, #6a2fc1 0%, #2e89d0 100%);
  color: $white;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 13px;
  text-transform: uppercase;

  @include with-quality-container {
    position: absolute;
    top: 4px;
    left: 4px;
    display: flex;
    align-items: stretch;
    aspect-ratio: 1;
    font-size: 11px;
    line-height: 11px;

    clip-path: path(
      "M58.3431 0H4C1.79086 0 0 1.79086 0 4V58.3431C0 61.9068 4.30857 63.6914 6.82843 61.1716L61.1716 6.82843C63.6914 4.30857 61.9068 0 58.3431 0Z"
    );
  }

  &__text {
    @include with-quality-container {
      rotate: -45deg;
    }

    &--small {
      @include with-quality-container {
        display: none;
      }
    }

    &--large {
      display: none;
      position: relative;
      top: -4px;
      left: -3px;

      @include with-quality-container {
        display: block;
      }
    }
  }
}
</style>
